export const MAX_INPUT_TOKENS = {
    incognito: 3000,
    gpt35Turbo: (128000 / 12),
    mistralLarge: (32000 / 4),
    //gpt4Turbo: (128000 / 4),
    //gpt4O: (128000 / 4),
    //gptO1: (128000 / 4),
    //gptO1Mini: (128000 / 4),
    //O3Mini: (200000 / 6),
    //claudeSonnet35: (200000 / 2),
    //claudeSonnet35v2: (200000 / 2),
    //claudeHaiku3: (200000 / 2),
    //mistralLarge: (32000 / 8 * 7),
    //kimi: (128000 / 2),
    //grok2: (131072 / 2),
    //grok2vision: (131072 / 2),
    //gemini20FlashLite: (1048576 / 2),
    //gemini20Flash: (1048576 / 2),
    //deepseekR1: (64000 / 2),
    //deepseekV3: (64000 / 2),
};
